import * as React from 'react'
import { styled, css, FontWeight } from '$utils/theme'
import { rem } from 'polished'
import {
  visibilityCss,
  horizontalMarginsCss,
  HorizontalMarginProps,
  verticalMarginsCss,
  VerticalMarginProps,
} from '$utils/theme/css'

export interface Props {
  className?: string
  content: string
  size?: IconSizeName
  isEditIcon?: boolean
  name?: string
  color?: string
  resize?: {
    height: any
    width: any
  }
  onClick?: any
  clickable?: boolean
  logo?: boolean
  kids?: boolean
  testId?: string
  rounded?: boolean
}

export type IconSizeName = 's' | 'm' | 'ml' | 'l' | 'xl' | 'xxl' | 'xxxl'

export const iconSize = {
  s: 10,
  m: 16,
  ml: 24,
  l: 32,
  xl: 40,
  xxl: 48,
  xxxl: 64,
}

const IconRaw: React.SFC<Props & HorizontalMarginProps & VerticalMarginProps> = ({
  content,
  className,
  onClick,
  testId,
}) => {
  const innerHtml = { __html: content }
  return <span data-testid={testId} className={className} dangerouslySetInnerHTML={innerHtml} onClick={onClick} />
}

export const Icon = styled(IconRaw).attrs({})<Props>`
  ${visibilityCss};
  ${horizontalMarginsCss};
  ${verticalMarginsCss}
  display: inline-block;
  margin-right: ${p => (p.marginRight ? rem(p.theme.sizes[p.marginRight]) : rem(p.theme.sizes.base))};

  > svg {
    width: 100%;
    height: 100%;

    > g, text {
      font-weight: ${FontWeight.bold};
    }

    path, use {
      fill: ${p => p.theme.colors[p.color]};
    }
  }

  ${p =>
    p.size &&
    css`
      width: ${rem(iconSize[p.size])};
      height: ${rem(iconSize[p.size])};
    `}
  ${p =>
    p.resize &&
    css`
      width: ${typeof p.resize.width === 'number' ? rem(p.resize.width) : p.resize.width};
      height: ${typeof p.resize.height === 'number' ? rem(p.resize.height) : p.resize.height};
    `}
  ${p =>
    p.rounded &&
    css`
      margin-right: ${rem(p.theme.sizes.none)};
      padding: ${rem(p.theme.sizes.mini)};
      background-color: ${p.theme.colors.lightYellow};
      border-radius: 50%;
    `}
  ${p =>
    p.isEditIcon &&
    css`
      position: absolute;
      bottom: 0;
      right: 0;
      border: 3px solid ${p.theme.colors.white};
      border-radius: 100%;
    `}

  ${p =>
    p.clickable &&
    css`
      &:hover {
        cursor: pointer;
      }
    `}

  ${p =>
    p.logo &&
    css`
      ${p.theme.media.onlyMobile`
          height: 1.4rem;
          ${p.kids &&
            css`
              height: 1.9rem;
            `}
        `};

      height: 1.7rem;
      ${p.kids &&
        css`
          height: 2.3rem;
        `}
      svg {
        width: auto;
      }
    `}
`



// WEBPACK FOOTER //
// ./src/views/components/Icon/Icon.tsx